import axios from 'axios'
import { Toast, Indicator  } from 'mint-ui';

axios.defaults.headers['Content-Type'] = 'application/json;charset=utf-8'
// 创建axios实例
const service = axios.create({
  // axios中请求配置有baseURL选项，表示请求URL公共部分
  baseURL: '/mobile',
  // 超时
  timeout: 300000
})
// 请求拦截器
// request拦截器
service.interceptors.request.use(
  config => {
    Indicator.open({
    	spinnerType: 'fading-circle',
      //样式
    });
    let obj = {
      thirdId: sessionStorage.getItem('thirdId'),
      companyCode: sessionStorage.getItem('companyCode'),
      unionId: sessionStorage.getItem('unionId'),
      thirdType: 'wechat'
    }
    if(config.params&&sessionStorage.getItem('thirdId')) {
      config.params = Object.assign({},config.params, obj)
    }
    if(config.data&&sessionStorage.getItem('thirdId')) {
      if (config.data.toString() == '[object FormData]') {
        let formData = config.data
        for(let key in obj) {
          formData.append(key, obj[key])
        }
        config.data = formData
      } else {
        config.data = Object.assign({},config.data, obj)
      }
    }
    return config
  },
  error => {
    Promise.reject(error)
  }
)

// 响应拦截器
service.interceptors.response.use(res => {
    const code = res.data.code
    Indicator.close();
    if (code !== '0000') {
      Toast(res.data.msg);
      return Promise.reject(new Error(res.data.msg || '系统异常，请联系管理员。'))
    } else {
      return res.data
    }
  },
  error => {
    Indicator.close();
    Toast('连接超时，请稍后再试');
  }
)


export default service



// WEBPACK FOOTER //
// ./src/utils/axios.js